module.exports = __webpack_public_path__ + "static/Logo-register-96d6b145642f45646ed4be0a5e307abb.png";